import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { ReviewSummaryField } from './ReviewSummaryField';

export const ReviewSummaryFieldExtension = FormFieldBlueprint.make({
  name: 'review-summary-field',
  params: {
    field: async () =>
      createFormField({
        name: 'ReviewSummaryField',
        component: ReviewSummaryField,
      }),
  },
});
